import { render, staticRenderFns } from "./GestioneAttivitaAttivitaViewComponent.vue?vue&type=template&id=049c3f56"
import script from "./GestioneAttivitaAttivitaViewComponent.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaAttivitaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports